import { Button, Inline, InlineItem, Stack, Text } from '@kinesis/bungle';
import { ScopePicker } from '@/components/scope-picker/scope-picker';
import type { OauthClient } from '@/api/oauth';

type Props = {
  client: OauthClient;
  scopes: string[];
  onScopesChange: (scopes: string[]) => void;
  onAllow: () => void;
  onDeny: () => void;
  busy?: boolean;
};

const ConsentCard = ({
  client,
  scopes,
  onScopesChange,
  onAllow,
  onDeny,
  busy = false,
}: Props) => {
  const allowDisabled = busy || scopes.length === 0;
  const description =
    `${client.client_name} can act on your behalf with the access you grant ` +
    'below. It can never do more than you allow here.';
  const caption = `Choose what ${client.client_name} can do on your behalf`;

  return (
    <Stack space='large'>
      <Stack space='small'>
        <Text>
          {client.client_name} is requesting access to your Kinesis account.
        </Text>
        {client.client_uri && (
          <Text>
            <a
              href={client.client_uri}
              target='_blank'
              rel='noopener noreferrer'
            >
              {client.client_uri}
            </a>
          </Text>
        )}
      </Stack>
      <ScopePicker
        value={scopes}
        onChange={onScopesChange}
        description={description}
        caption={caption}
      />
      <Inline>
        <InlineItem sizing='fill-container' />
        <InlineItem>
          <Button variant='secondary' onClick={onDeny} disabled={busy}>
            Deny
          </Button>
        </InlineItem>
        <InlineItem>
          <Button onClick={onAllow} disabled={allowDisabled}>
            Allow
          </Button>
        </InlineItem>
      </Inline>
    </Stack>
  );
};

export { ConsentCard };
